// src/locales/si/pos.js — Sinhala
import { pos as posEn } from '../en/pos';

export const pos = {
  ...posEn,
  session: 'සැසිය',
  paymentFee: 'ගාස්තුව',
  feeAbsorbed: 'ව්‍යාපාරය',
  feeChargedToCustomer: 'ගනුදෙනුකරු',
  totalPaymentFees: 'මුළු ගෙවීම් ගාස්තු',
  paymentFeesCustomer: 'ගාස්තු (ගනුදෙනුකරු)',
  productCostCol: 'පිරිවැය',
  paymentFeesCol: 'ගාස්තු',
  profitCol: 'ලාභය',
  totalProductCost: 'නිෂ්පාදන පිරිවැය',
  grossProfit: 'මළු ලාභය',
  searchOrdersPlaceholder: 'ඇණවුම් #, ගනුදෙනුකරු නම, දුරකථනය සොයන්න...',
  filterByCustomer: 'ගනුදෙනුකරු අනුව පෙරන්න',

  // Dynamic order status labels
  status_completed:          'සම්පූර්ණ',
  status_voided:             'අවලංගු',
  status_on_hold:            'රඳවා ගත',
  status_credit:             'ණය',
  status_returned:           'ආපසු',
  status_partially_returned: 'අර්ධ ආපසු',

  // Dynamic payment status labels
  payment_paid:    'ගෙවා ඇත',
  payment_partial: 'අර්ධ',
  payment_unpaid:  'නොගෙවූ',

  // Payment method keys
  bank_transfer: 'බැංකු හුවමාරුව',

  // Receipt share buttons
  shareInvoice: 'ඉන්වොයිස් බෙදා ගන්න',
  sendViaWhatsApp: 'WhatsApp',
  sendViaSms: 'SMS යවන්න',
  sendingInvoice: 'යවමින්…',
  smsSent: 'SMS යවන ලදී',
};
